export default "__VITE_ASSET__BYY$uVro__"